/* CUSTOM: collection banner read-more clamp (pre-measure fix) */
(() => {
  const SEL = '[id^="shopify-section-"][id*="banner"] .collection-hero__description.rte';

  function needsClamp(el, lines = 2) {
    const cs = getComputedStyle(el);
    const lh = parseFloat(cs.lineHeight) || parseFloat(cs.fontSize) * 1.2;
    return el.scrollHeight > lh * lines + 1; // natural height vs N lines
  }

  function clampify(root = document) {
    root.querySelectorAll(SEL).forEach((el) => {
      if (el.dataset.rm || !el.textContent.trim()) return;

      // Measure BEFORE restructuring
      const shouldClamp = needsClamp(el, 2);
      if (!shouldClamp) { el.dataset.rm = '1'; return; }

      el.dataset.rm = '1';

      const wrap = document.createElement('div');
      const clip = document.createElement('div');
      const btn  = document.createElement('button');

      wrap.className = 'rmx';
      clip.className = 'rmc';
      btn.className  = 'rmt';
      btn.type = 'button';
      btn.textContent = 'Read more';
      btn.setAttribute('aria-expanded', 'false');

      while (el.firstChild) clip.appendChild(el.firstChild);
      wrap.appendChild(clip);
      el.appendChild(wrap);

      btn.onclick = () => {
        wrap.classList.toggle('e');
        const expanded = wrap.classList.contains('e');
        btn.textContent = expanded ? 'Read less' : 'Read more';
        btn.setAttribute('aria-expanded', String(expanded));
      };
      wrap.appendChild(btn);
    });
  }

  document.addEventListener('DOMContentLoaded', () => clampify());
  document.addEventListener('shopify:section:load', (e) => clampify(e.target));
  document.addEventListener('shopify:section:select', (e) => clampify(e.target));
})();

